import { render, staticRenderFns } from "./problem-add.vue?vue&type=template&id=c36b8e84&scoped=true&"
import script from "./problem-add.vue?vue&type=script&lang=js&"
export * from "./problem-add.vue?vue&type=script&lang=js&"
import style0 from "./problem-add.vue?vue&type=style&index=0&lang=css&"
import style1 from "./problem-add.vue?vue&type=style&index=1&id=c36b8e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36b8e84",
  null
  
)

export default component.exports